import { Injectable } from "@angular/core";
import { IPRFIContractRequirement } from "../api-generated";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalContractRequirementService extends BaseService<IPRFIContractRequirement> {}
